export default 'assessments'
